export default "__VITE_ASSET__D60gCEK3__"